import { useNavigate } from "react-router-dom";
import { Eye, PencilSimple, Plus, Prohibit, Trash } from "@phosphor-icons/react";

const money = (amount) => {
  return new Intl.NumberFormat("en-MY", {
    style: "currency",
    currency: "MYR",
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

export default function CustomerTable({ customers, isAdmin, onBorrow, onEdit, onDelete }) {
  const navigate = useNavigate();
  return (
    <div className="table-wrap customer-table-wrap" data-testid="customers-table">
      <table>
        <thead>
          <tr>
            <th>Borrow</th>
            <th>Agent Name</th>
            <th>Customer Name</th>
            <th>IC / Passport</th>
            <th>Occupation</th>
            <th>Address</th>
            <th className="amount">Outstanding</th>
            <th>View</th>
            <th>Edit</th>
            {isAdmin && <th>Delete</th>}
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr
              key={customer.id}
              data-testid={`customer-row-${customer.id}`}
              className={customer.has_blacklisted_loan ? "customer-blacklisted-row" : ""}
            >
              <td>
                <button
                  className="borrow-button"
                  onClick={() => onBorrow(customer)}
                  data-testid={`borrow-customer-${customer.id}`}
                >
                  <Plus size={13} /> Borrow
                </button>
              </td>
              <td>{customer.owner_name}</td>
              <td>
                <strong>{customer.full_name}</strong>
                {customer.has_blacklisted_loan && (
                  <span
                    className="customer-blacklist-alert"
                    data-testid={`customer-blacklisted-alert-${customer.id}`}
                  >
                    Blacklisted loan
                  </span>
                )}
              </td>
              <td>{customer.ic_passport}</td>
              <td>{customer.occupation}</td>
              <td className="customer-address">{customer.address}</td>
              <td className={`amount ${customer.outstanding ? "customer-outstanding" : ""}`}>
                {money(customer.outstanding)}
              </td>
              <td>
                <div className="customer-view-actions">
                <button
                  className="customer-icon-button"
                  onClick={() => navigate(`/customer-record/${customer.id}`)}
                  data-testid={`view-customer-${customer.id}`}
                  aria-label={`View ${customer.full_name} record`}
                >
                  <Eye size={17} />
                </button>
                {customer.has_blacklisted_loan && (
                  <span
                    className="customer-blacklist-icon"
                    role="img"
                    title="Customer has a blacklisted loan"
                    aria-label="Customer has a blacklisted loan"
                    data-testid={`customer-blacklisted-icon-${customer.id}`}
                  >
                    <Prohibit size={18} weight="bold" />
                  </span>
                )}
                </div>
              </td>
              <td>
                <button
                  className="customer-icon-button"
                  onClick={() => onEdit(customer)}
                  data-testid={`edit-customer-${customer.id}`}
                  aria-label={`Edit ${customer.full_name}`}
                >
                  <PencilSimple size={17} />
                </button>
              </td>
              {isAdmin && (
                <td>
                  <button
                    className="customer-icon-button customer-delete-button"
                    onClick={() => onDelete(customer)}
                    data-testid={`delete-customer-${customer.id}`}
                    aria-label={`Delete ${customer.full_name}`}
                  >
                    <Trash size={17} />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {!customers.length && (
        <div className="empty-state" data-testid="customers-empty-state">
          No customers match this search.
        </div>
      )}
    </div>
  );
}